<template>
  <section
    class="component-a8fee867"
    resmed-component-name="feature_fullwidth_h81_text_2cta"
    :style="{
      height:
        acf.layout.section_height !== ''
          ? acf.layout.section_height + 'vh'
          : '100vh',
    }"
  >
    <div class="component">
      <figure
        class="embed-responsive"
        v-bind:class="{
          'embed-responsive-16by9': $root.mode === 'lg' || $root.mode === 'xl',
          'embed-responsive-4by3': $root.mode === 'md',
          'embed-responsive-33by40': $root.mode === 'xs' || $root.mode === 'sm',
        }"
        :style="{
          height:
            acf.layout.section_height !== ''
              ? acf.layout.section_height + 'vh'
              : '100vh',
        }"
      >
        <template v-if="acf.layout.background === 'image'">
          <div
            class="hero-bg embed-responsive-item"
            v-bind:style="{ 'background-image': `url(${acf.layout.image})` }"
          ></div>
        </template>

        <template v-if="acf.layout.background === 'video'">
          <background-video
            v-bind:file="video"
            v-bind:img="acf.layout.video_replacement"
            :key="componentKey"
          ></background-video>
        </template>

        <div class="wrapper px-xs-sm-2">
          <div class="container">
            <div class="row">
              <div class="col offset-md-1">
                <figcaption>
                  <h1 style="display: none">{{ acf["h1-seo"] }}</h1>
                  <h2
                    :style="{
                      fontSize:
                        acf.layout.headline_font_size !== ''
                          ? acf.layout.headline_font_size
                          : '5rem',
                      textAlign: acf.placement.toLowerCase(),
                    }"
                    class="display"
                    v-html="acf.headline"
                  ></h2>
                </figcaption>
                <div v-if="acf.introduction" class="introduction pt-3 pb-4">
                  <p>{{ acf.introduction }}</p>
                </div>
                <div v-if="acf.cta.text">
                  <a
                    v-if="acf.modal.player"
                    href="#"
                    class="btn cta-pill filled-red icon right-arrow"
                    v-bind:modal-video-id="acf.modal.id"
                    v-on:click.prevent="modal(acf.modal.player, acf.modal.id, acf.modal.aprimo_url, acf.modal.aprimo_subtitle)"
                    >{{ acf.cta.text }}</a
                  >
                  <a
                    v-else
                    v-bind:href="acf.cta.href"
                    v-bind:target="acf.cta.target"
                    class="btn cta-pill filled-red icon right-arrow"
                    >{{ acf.cta.text }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </figure>
    </div>
  </section>
</template>

<script>
import debounce from "lodash/debounce";
import backgroundVideo from "../shared-support/background-video";

export default {
  name: "component-a8fee867", // feature_fullwidth_h81_text_2cta
  props: ["acf"],
  components: {
    backgroundVideo,
  },
  data() {
    return {
      video: "", // video file
      componentKey: 0,
    };
  },
  methods: {
    modal(...arg) {
      bus.$emit("overlay:active", {
        active: true,
        player: arg[0],
        id: arg[1],
        aprimo_url: arg[2] || null,
        aprimo_subtitle: arg[3] || null,
      });
    },
    forceRerender() {
      this.componentKey += 1;
    },
    debounce: debounce(function (arr) {
      // initial load
      if (!arr[1]) {
        this.video =
          arr[0] === "lg" || arr[0] === "xl"
            ? (this.video = this.acf.layout.video_16by9)
            : (this.video = this.acf.layout.video_4by3);

        this.forceRerender();
      }

      // from --> lg xl
      // to   --> xs sm md
      if (
        (arr[0] === "xs" || arr[0] === "sm" || arr[0] === "md") &&
        (arr[1] === "lg" || arr[1] === "xl")
      ) {
        this.video = this.acf.layout.video_4by3;
        this.forceRerender();
      }

      // from --> xs sm md
      // to --> lg xl
      if (
        (arr[0] === "lg" || arr[0] === "xl") &&
        (arr[1] === "xs" || arr[1] === "sm" || arr[1] === "md")
      ) {
        this.video = this.acf.layout.video_16by9;
        this.forceRerender();
      }
    }, 100),
  },
  created() {
    bus.$on("mode", (arr) => {
      this.debounce(arr);
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-a8fee867 {
  // -->
}

.component {
  figure {
    background-color: $cc-resmed-black;

    .hero-bg {
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;

      opacity: 0.7;

      @media (min-width: 992px) {
        background-size: cover;
        opacity: 1;
      }
    }
  }

  h2 {
    @extend %display;

    margin: 0;
    color: rgba($cc-resmed-white, 0.875);
  }

  .introduction {
    max-width: 550px;

    * {
      color: $cc-resmed-white;
    }
  }

  .wrapper {
    min-width: 100vw;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>